import { Link } from 'react-router-dom';
import { Instagram, Facebook, Mail, Phone, MapPin } from 'lucide-react';

const footerLinks = {
  esplora: [
    { name: 'La Villa', href: '/la-villa' },
    { name: 'Estate 2027', href: '/estate-2027' },
    { name: 'Abbonamenti', href: '/abbonamenti' },
    { name: 'Eventi Privati', href: '/eventi-privati' },
    { name: 'Night Events', href: '/night-events' },
    { name: 'Shop', href: '/shop' },
  ],
  informazioni: [
    { name: 'FAQ', href: '/faq' },
    { name: 'Contatti', href: '/contatti' },
    { name: 'Come Raggiungerci', href: '/contatti#mappa' },
    { name: 'Regolamento', href: '/regolamento' },
  ],
  legale: [
    { name: 'Privacy Policy', href: '/privacy' },
    { name: 'Cookie Policy', href: '/cookie' },
    { name: 'Termini e Condizioni', href: '/termini' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-night text-ivory pt-24 pb-8" data-testid="footer">
      <div className="max-w-[1800px] mx-auto px-6 md:px-12 lg:px-24">
        {/* Main Tagline */}
        <div className="mb-20">
          <p className="font-accent text-5xl md:text-7xl lg:text-8xl italic text-stone-400 leading-tight">
            "Ogni gesto,<br />una firma."
          </p>
        </div>
        
        {/* Links Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-12 mb-16">
          {/* Brand Column */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="mb-6 inline-block md:-ml-3" data-testid="footer-logo">
              <img src="/images/logo-new-white.png" alt="La Villa" className="h-12" />
            </Link>
            <p className="font-body text-stone-400 text-sm leading-relaxed mb-6">
              Oltre 30 anni di storia. Villa con piscina, aperitivo al tramonto, musica ed eventi privati.
            </p>
            <div className="flex gap-4">
              <a
                href="https://www.instagram.com/la_villa.cf"
                target="_blank"
                rel="noopener noreferrer"
                className="text-stone-400 hover:text-champagne transition-colors"
                data-testid="social-instagram"
              >
                <Instagram size={20} strokeWidth={1.5} />
              </a>
              <a
                href="https://www.facebook.com/LaVillaCF"
                target="_blank"
                rel="noopener noreferrer"
                className="text-stone-400 hover:text-champagne transition-colors"
                data-testid="social-facebook"
              >
                <Facebook size={20} strokeWidth={1.5} />
              </a>
            </div>
          </div>
          
          {/* Esplora */}
          <div>
            <h4 className="font-body text-xs uppercase tracking-[0.2em] text-champagne mb-6">
              Esplora
            </h4>
            <ul className="space-y-3">
              {footerLinks.esplora.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="font-body text-sm text-stone-400 hover:text-ivory transition-colors"
                    data-testid={`footer-link-${link.name.toLowerCase().replace(' ', '-')}`}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          
          {/* Informazioni */}
          <div>
            <h4 className="font-body text-xs uppercase tracking-[0.2em] text-champagne mb-6">
              Informazioni
            </h4>
            <ul className="space-y-3">
              {footerLinks.informazioni.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="font-body text-sm text-stone-400 hover:text-ivory transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          
          {/* Contatti */}
          <div>
            <h4 className="font-body text-xs uppercase tracking-[0.2em] text-champagne mb-6">
              Contatti
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-stone-400">
                <MapPin size={18} strokeWidth={1.5} className="mt-0.5 flex-shrink-0" />
                <span className="font-body text-sm">
                  Via Emilia Est 85/b<br />
                  41013 Castelfranco Emilia (MO)
                </span>
              </li>
              <li className="flex items-center gap-3 text-stone-400">
                <Phone size={18} strokeWidth={1.5} />
                <a href="tel:+393514504629" className="font-body text-sm hover:text-ivory transition-colors">
                  +39 351 450 4629
                </a>
              </li>
              <li className="flex items-center gap-3 text-stone-400">
                <Mail size={18} strokeWidth={1.5} />
                <a href="mailto:lavilla.cf@gmail.com" className="font-body text-sm hover:text-ivory transition-colors">
                  lavilla.cf@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        {/* Bottom Bar */}
        <div className="border-t border-stone-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <div>
            <p className="font-body text-xs text-stone-500">
              © 2025 La Villa. Tutti i diritti riservati.
            </p>
            <p className="font-body text-xs text-stone-600 mt-1">
              La Villa è un marchio gestito da Nemesis Srl
            </p>
          </div>
          <div className="flex gap-6">
            {footerLinks.legale.map((link) => (
              <Link
                key={link.name}
                to={link.href}
                className="font-body text-xs text-stone-500 hover:text-stone-400 transition-colors"
              >
                {link.name}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
